export interface IErrorDetails {
  [key: string]: string[];
}
